import React, { useEffect, useRef, useState } from 'react'
// import Slider from 'react-slick'
import Icons from '../icons'
import { useFetchAdvertisement } from '../../../pages/Home/api'
import mainImage from '../../../assets/images/advertisementMain.png'
import titleBg from '../../../assets/images/adBg.png'
import Slider from 'react-slick'
// import LeftArrow from '../icons/LeftArrow'
// import RightArrow from '../icons/RightArrow'
interface InitialPopupProps {
  autoClose?: boolean
  closeAfter?: number
}

const InitialPopup: React.FC<InitialPopupProps> = ({
  autoClose = false,
  closeAfter = 10000,
}) => {
  const [show, setShow] = useState(true)
  const [animate, setAnimate] = useState(false)
  const { data, isLoading, isError } = useFetchAdvertisement()
  const sliderRef = useRef<Slider | null>(null)
  // const handleNext = () => {
  //   sliderRef.current?.slickNext()
  // }

  // const handlePrev = () => {
  //   sliderRef.current?.slickPrev()
  // }
  useEffect(() => {
    setTimeout(() => setAnimate(true), 100)
    document.body.style.overflow = 'hidden'

    if (autoClose) {
      const timer = setTimeout(() => {
        setShow(false)
      }, closeAfter)
      return () => {
        clearTimeout(timer)
        document.body.style.overflow = ''
      }
    }

    return () => {
      document.body.style.overflow = ''
    }
  }, [autoClose, closeAfter])
  const handleClose = () => {
    setShow(false)
    document.body.style.overflow = ''
  }

  if (!show) return null

  if (isLoading) {
    return (
      <div className="text-center mt-6 text-gray-500">Loading schemes...</div>
    )
  }

  if (isError || !data?.data?.length) {
    return (
      <div className="text-center mt-6 text-red-500">
        Failed to load schemes.
      </div>
    )
  }

  const settings = {
    dots: false,
    arrows: false,
    infinite: data?.data?.length > 1,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: data?.data?.length > 1,
    autoplaySpeed: 2000,
  }
  console.log(data)
  return (
    <div className="fixed inset-0 z-[9999] flex justify-center items-center transition-opacity duration-300 ease-in-out">
      <div className="absolute inset-0 bg-white bg-opacity-20 backdrop-blur-md" />
      <div
        className={`relative bg-white rounded-lg drop-shadow-[0_-4px_6px_rgba(0,0,0,0.1)] overflow-hidden w-full max-w-5xl min-h-AdPopupHeight pt-12 transform transition-all duration-500 ease-out
        ${animate ? 'opacity-100 scale-100' : 'opacity-0 scale-90'}`}
      >
        {/* <button
          onClick={handlePrev}
          className="absolute left-0 top-1/2 transform -translate-y-1/2 z-10 rounded-full p-3 hidden lg:block"
        >
          <LeftArrow />
        </button> */}

        <button onClick={handleClose} className="absolute top-3 right-4">
          <Icons
            className="opacity-100 group-hover:opacity-0"
            name="advertisement-close"
          />
        </button>

        <Slider {...settings} ref={sliderRef}>
          {data.data.map((ad: any) => (
            <div key={ad.id}>
              <div className="flex flex-col md:flex-row items-start gap-5 mt-2 px-4 sm:px-6 md:px-0">
                <div className="w-full md:w-[45%] justify-center items-center md:pl-16">
                  <div className="items-end justify-end flex mb-14 mr-14">
                    <img
                      src={mainImage}
                      alt="Internship Promotion"
                      className="w-72 h-10"
                    />
                  </div>
                  <div
                    className="bg-no-repeat bg-cover bg-center p-4 min-h-[208px]"
                    style={{ backgroundImage: `url(${titleBg})` }}
                  >
                    <h1
                      className="text-3xl md:text-4xl font-bold leading-snug text-adYellow stroke-text text-left"
                      style={{
                        WebkitTextStroke: '1px #000',
                        fontFamily: "'Noto Sans Malayalam', sans-serif",
                        overflowWrap: 'break-word',
                        wordBreak: 'break-word',
                      }}
                    >
                      {ad.title}
                    </h1>
                  </div>
                </div>

                <div className="w-full md:w-[47%] h-56 sm:h-64 md:h-[320px] flex justify-center items-center">
                  {ad.file ? (
                    <video
                      controls
                      className="w-full h-full object-cover rounded-md"
                    >
                      <source src={ad.file} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  ) : (
                    <img
                      src={ad.image}
                      alt="Ad Banner"
                      className="w-full h-full object-cover rounded-md"
                    />
                  )}
                </div>
              </div>

              <div className="px-4 sm:px-8 md:px-16 pt-6 font-medium">
                <div
                  className="text-base"
                  dangerouslySetInnerHTML={{ __html: ad.description }}
                />
              </div>
            </div>
          ))}
        </Slider>
        {/* <button
          onClick={handleNext}
          className="absolute right-0 top-1/2 transform -translate-y-1/2 z-10 rounded-full p-3 hidden lg:block"
        >
          <RightArrow />
        </button> */}
      </div>
    </div>
  )
}

export default InitialPopup
